// app/javascript/controllers/inline_save_controller.js
import {Controller} from "stimulus";

export default class extends Controller {
    initialize() {
        this.timeout = null;
    }

    save() {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => this._submit(), 300);
    }

    _submit() {
        const url = this.element.dataset.inlineSaveUrlValue;
        if (!url) {
            console.error("Inline save: missing data-inline-save-url-value");
            return;
        }

        const inputs = this.element.querySelectorAll("input[name], select[name]");
        const body = new URLSearchParams();
        inputs.forEach(input => {
            if (input.type === "checkbox") {
                if (input.type === "checkbox" && input.value === "0") return;
                body.set(input.name, input.checked ? "1" : "0");
            } else {
                body.set(input.name, input.value);
            }
        });

        const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;

        fetch(url, {
            method: "PATCH",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "Accept": "text/vnd.turbo-stream.html",
                "X-CSRF-Token": csrfToken
            },
            body: body.toString()
        }).then(response => {
            if (response.ok) return response.text();
            throw new Error("Save failed");
        }).then(html => {
            if (html) Turbo.renderStreamMessage(html);
        }).catch(error => {
            console.error("Inline save failed:", error);
        });
    }
}
